import React from 'react'
import { connect } from 'react-redux'
import { RootState } from 'Store'
import { Col, Row } from 'antd'
import { selectCurrentUser } from 'Store/user/selector'
import { DocumentConfigKey } from 'helpers/constanst'
import SaleOrderPDF from 'Pages/SupplierOrder/components/SaleOrderPDF'
import { selectConfigList } from 'Store/pos/selector'
import { getConfigByKey } from 'helpers/format'

type Props = ReduxProps & {
  title: string
  orderDetail: any
  saleOrderPDF: any
  saleOrderLitePDF: any
}

const SaleOrderPDFDetail: React.FunctionComponent<Props> = props => {
  const { orderDetail, saleOrderPDF, saleOrderLitePDF, title, configList } = props
  const configData = getConfigByKey(configList, DocumentConfigKey.DELIVERY)

  return (
    <>
      <Row ref={saleOrderPDF}>
        <Col span={24}>
          <SaleOrderPDF detail={orderDetail} title={title} configData={configData} />
        </Col>
      </Row>
      <Row ref={saleOrderLitePDF}>
        <Col span={24}>
          <SaleOrderPDF detail={orderDetail} isLite={true} title={title} configData={configData} />
        </Col>
      </Row>
    </>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    configList: selectConfigList(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(SaleOrderPDFDetail)
